/**
 * @deprecated delete when cleaning up fun-1689_single_root_smart_card_provider
 */
const ProjectFragment = `
fragment ProjectFragment on JiraProject {
  id
  projectId
  key
  uuid
  name
  avatar {
    medium
  }
  projectType
  projectStyle
  status
  created
}
`;

/**
 * @deprecated delete when cleaning up fun-1689_single_root_smart_card_provider
 */
export const PROJECT_BY_KEY_QUERY = `
query jiraProjectByKey($projectKey: String!, $cloudId: ID!) {
  jira {
    jiraProjectByKey(key: $projectKey, cloudId: $cloudId) {
      ...ProjectFragment
    }
  }
}
${ProjectFragment}
`;

/**
 * @deprecated delete when cleaning up fun-1689_single_root_smart_card_provider
 */
export const PROJECT_BY_ID_QUERY = `
query jiraProject($projectAri: ID!) {
  jira {
    jiraProject(id: $projectAri) {
      ...ProjectFragment
    }
  }
}
${ProjectFragment}
`;

export const QUERY = `
query jiraProject($cloudId: ID!, $projectIdOrKey: String!) {
  jira_projectByIdOrKey(cloudId: $cloudId, idOrKey: $projectIdOrKey) {
    id
    projectId
    key
    uuid
    name
    avatar {
      medium
    }
    projectType
    projectStyle
    status
    created
    isAIEnabled
    canAdministerProject: action(type:EDIT_PROJECT_CONFIG) {
      canPerform
    }
  }
}`;
